export const RECIPE_MEDICINE_FORM = 'recipesMedicine'
export const REACTIONS_FORM_ID = 'adverseReactions'
export const EXISTING_TREATMENT_PLAN = 'treatmentPlanId'
export const EXISTING_PREGNANCY_PLAN = 'pregnancyPlanId'
export const INVESTIGATION_MEDICINE_FORM = 'investigationMedicine'
export const LATEST_CONSULTATION_ID = 'latestConsultationId'

export const RECIPES_CONSUMABLES_FIELDS = [
  'internationalNameId',
  'internalInventoryItemId',
  'productFormId',
  'productFormName',
  'name',
  'dispensedAmount',
  'id',
  'stockQuantity'
]

export const MIN_PREGNANCY_AGE = 12
export const MAX_PREGNANCY_AGE = 60
